import apiService from "@/services/apiService";
import apiUrls from "@/services/apiUrls";

const state = {
  data: {},
};

const getters = {
  init: (state) => state.data,
};

const actions = {
  async getInit({ commit }) {
    try {
      let response = await apiService.get(apiUrls.INIT);
      commit("getInit", response.data);
    } catch (error) {
      console.log(error);
    }
  },
};

const mutations = {
  getInit: (state, data) => (state.data = data),
};

export default {
  state,
  getters,
  actions,
  mutations,
};